import { computed, ref } from "vue";

export const appClassOverrides = ref<string[]>([]);


const SCREEN_WIDTH = ref(window.innerWidth);

export const updateWindowWidth = ()=>{
    SCREEN_WIDTH.value = window.innerWidth;
};


const screenSizeClass = computed(()=>{
    if(SCREEN_WIDTH.value >= SIZE_DESKTOP){
        return "size-desktop";
    }else if(SCREEN_WIDTH.value > SIZE_MOBILE ){
        return "size-tablet";
    }else{
        return "size_mobile";
    }
});


/**
 * Used to add CSS classes to the root #app element
 */
export const appClasses = computed(() => {
    const cls = [];

    cls.push("inset-gutter-10px");
    cls.push(`platform-${PLATFORM}`);
    cls.push(screenSizeClass.value);
    cls.push(...appClassOverrides.value);

    return cls;
});